import { createBrowserHistory } from 'history';
// import ReactGA from 'react-ga';
export const history = createBrowserHistory();

// Initialize google analytics page view tracking
history.listen(location => {
    // ReactGA.set({ page: location.pathname }); // Update the user's current page
    // ReactGA.pageview(location.pathname); // Record a pageview for the given page
});


// WEBPACK FOOTER //
// ./src/_helpers/history.js